// Folder picks / drops -> [{ file, path }] with the folder path kept ("Trip/Day 1/a.jpg")
export const fromPicker = (files) => Array.from(files).map((file) => ({ file, path: file.webkitRelativePath || file.name }));

const readAll = (reader) => new Promise((resolve, reject) => {
  const out = [];
  const next = () => reader.readEntries((batch) => (batch.length ? (out.push(...batch), next()) : resolve(out)), reject);
  next();
});

const walk = async (entry, out) => {
  if (entry.isFile) {
    const file = await new Promise((res, rej) => entry.file(res, rej));
    out.push({ file, path: entry.fullPath.replace(/^\/+/, "") });
  } else if (entry.isDirectory) {
    for (const child of await readAll(entry.createReader())) await walk(child, out);
  }
};

// null when nothing dropped is a folder (plain file drop)
export const fromDrop = async (dataTransfer) => {
  const entries = Array.from(dataTransfer.items || []).map((i) => i.webkitGetAsEntry?.()).filter(Boolean);
  if (!entries.some((e) => e.isDirectory)) return null;
  const out = [];
  for (const e of entries) await walk(e, out);
  return out;
};
